export const GTM_ID = process.env.GTM_ID

declare const window: Window['window'] & {
  dataLayer: Record<string, unknown>[]
}

/**
 * Google Optimizeの発火
 */
export const optimize = (): void => {
  window.dataLayer.push({ event: 'optimize.activate' })
}
